/**
 * This function exists because:
 * NuxtImg `src` prop type accepts empty string/undefined
 * but actually breaks in SSR if you pass those.
 * We need to provide some src, and this 1x1px image works
 */
export const getImageStubSrc = (): string => '/stub-image.jpg'

export const getIconSrc = (
  iconName: `${string}.${string}`,
  { leadingSlash = true, origin = '' } = {},
): string => {
  const leadingSlashPart = (leadingSlash && !origin) ? '/' : ''
  const originPart = origin ? `${origin}/` : ''

  // ATTENTION: if you change this, change it in site.webmanifest too
  return `${leadingSlashPart}${originPart}app-store-icons/${iconName}`
}

export const getIconManifestSrc = (origin = ''): string => `${origin}/site.webmanifest`
